import React from 'react'
import { countLabel } from '@/utils/plural'
import AvatarStack from './AvatarStack'
import { OverviewHero } from './core'
import {
	DaysPill,
	HeroAvatars,
	HeroCenter,
	HeroDates,
	HeroMeta,
	HeroTitle,
	HeroTopBar,
	HeroWrap,
} from './Hero.styles'

interface HeroProps {
	hero: OverviewHero
	/** Navigates to the members page when the avatar stack is activated. */
	onAvatarsClick?: () => void
	/** Optional control rendered top-right (e.g. member-mode Trip Settings). */
	action?: React.ReactNode
}

/** Trip overview hero: title, days pill + dates, and a members avatar stack. */
const Hero: React.FC<HeroProps> = ({ hero, onAvatarsClick, action }) => (
	<HeroWrap>
		<HeroTopBar>{action}</HeroTopBar>
		<HeroCenter>
			<HeroTitle>{hero.name}</HeroTitle>
			{hero.hasDates && (
				<HeroMeta>
					<DaysPill>
						{countLabel(hero.dayCount, 'day')}
					</DaysPill>
					{hero.dateRange && <HeroDates>{hero.dateRange}</HeroDates>}
				</HeroMeta>
			)}
			{hero.memberCount > 0 && (
				<HeroAvatars>
					<AvatarStack
						travelers={hero.travelers}
						memberCount={hero.memberCount}
						size={34}
						showNames
						onClick={onAvatarsClick}
					/>
				</HeroAvatars>
			)}
		</HeroCenter>
	</HeroWrap>
)

export default Hero
